import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { getQueryTimeoutMs } from '#pplx/frontend/api-clients/core/utils.js';
import { logger } from '#pplx/frontend/logger/browser.js';
import { attributionClient } from '#pplx_generated/typespec/rest/attribution/client.js';
export const trackDubLead = async ({ eventName, isDeferred, clickId, nextauthUserId, reason, }) => {
    try {
        const { data, error, response } = await attributionClient.POST('/rest/attribution/dub/lead', reason, {
            timeoutMs: getQueryTimeoutMs(),
            body: {
                event_name: eventName,
                is_deferred: isDeferred,
                click_id: clickId,
                nextauth_user_id: nextauthUserId,
            },
        });
        if (error) {
            throw new ApiClientsError('API_CLIENTS_ERROR', {
                cause: error,
                status: response.status ?? 0,
            });
        }
        return {
            success: data?.success ?? false,
        };
    }
    catch (err) {
        logger.error('Failed to save post install redirect', err);
        return {
            success: false,
        };
    }
};
//# sourceMappingURL=trackDubLead.js.map